import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/inspection-readiness")({
  head: () => buildRouteHead("/en/services/inspection-readiness", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/quality-assurance/regulatory-inspection-readiness", replace: true });
  },
});
